/*
 * lp-saftkur-probiertag-pdp-nutrition
 * ARIA-Tabs: Klick, Pfeiltasten, Pos1/Ende. Panels sind serverseitig gerendert.
 */
if (!customElements.get('lpsk-tabs')) {
  customElements.define(
    'lpsk-tabs',
    class LpskTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.tabs.length) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index, false));
          tab.addEventListener('keydown', (event) => {
            let next = null;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === null) return;
            event.preventDefault();
            this.activate(next, true);
          });
        });
      }

      activate(index, focus) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        const active = this.tabs[index];
        if (focus) active.focus();
        active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
  );
}
